export default __webpack_public_path__ + "static/media/lp-01-header-02-desktop.08aff337.png";